import { Box, Grid, Typography, Stack, Link, CircularProgress } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Layout from './Layout';
import { ReservationUrls } from '@/features/reservation/constants/urls';
import { executeGet } from '@/client/rest';
import { FacilityResponseType } from '@/features/reservation/types/FacilityResponseType';

export function FacilityListForm(props: any) {
  const [pause, setPause] = useState(false);
  const [facilityList, setFacilityList] = useState<any | null>(null);
  const [searchParams] = useSearchParams();

  const redirect = searchParams.get('redirect') || ReservationUrls.Reservation;
  const navigate = useNavigate();

  useEffect(() => {
    if (pause) return;
    const timer = setInterval(async () => {
      const res = (await executeGet<FacilityResponseType>({
        apiName: 'medirecoWebApi',
        path: '/get-facility-list'
      })) as any;
      setFacilityList((res as any)['facilities']);
      setPause(true);
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  });

  return (
    <Layout title="施設一覧" backButton handleBack={() => navigate(-1)}>
      <Box sx={{ p: 2 }}>
        <Grid container direction={'row'} spacing={2} justifyContent={'center'}>
          <Grid item xs={12} md={6} sm={8}>
            <Grid container direction={'column'} spacing={2}>
              <Grid item xs={12} maxWidth={'100%'} mt={1}>
                <Stack direction={'column'}>
                  {facilityList ? (
                    Object.values(facilityList)?.map((data: any, i) => {
                      return (
                        <Link
                          key={i}
                          onClick={() => {
                            // クエリパラメータの施設IDから施設情報を読み込んでいる
                            return navigate(`${redirect}?fid=${data.id}`);
                          }}
                          underline="none"
                          color="inherit"
                          mt={2}
                        >
                          <Grid
                            container
                            direction={'row'}
                            alignItems={'center'}
                            py={2}
                            borderRadius={1}
                            sx={{ backgroundColor: 'white' }}
                          >
                            <Typography className="font-bold" ml={1} mr={'auto'}>
                              {data.facility_name}
                            </Typography>
                            <Grid ml={'auto'} mr={1}>
                              <ArrowForwardIosIcon sx={{ fontSize: 16 }} />
                            </Grid>
                          </Grid>
                        </Link>
                      );
                    })
                  ) : (
                    <Grid position={'absolute'} sx={{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                      <CircularProgress size={'2rem'} color="inherit" />
                    </Grid>
                  )}
                </Stack>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Layout>
  );
}
